import {Header, Icon} from "semantic-ui-react";
import React, {Component} from 'react';

export class NotValidContent extends Component {
    render() {
        return (<div>
            <Header as='h1' icon textAlign='center'>
                <Icon name='exclamation triangle'/>
                Перепрошуємо, щось пішло не за планом!
                <Header.Subheader>
                    Спробуйте, будь ласка, спробувати ще раз або ж <a href="mailto: support@easyms.co">звернутися
                    у нашу неймовірну технічну підтримку</a>
                </Header.Subheader>
            </Header>
        </div>)
    }
}


// WEBPACK FOOTER //
// ./src/NotValidContent.js